module.exports = __webpack_public_path__ + "img/lg_ring_g_0_0_1.441da4e9.png";